<template>
    <header class="d-flex align-items-center">
        <div class="brand navbar navbar-dark w-100">
            <a class="navbar-brand d-flex align-items-center" :href="routes.LANDING">
                <img class="brand-logo"
                     :src="cdnUrl('/img/logo.png')"
                     alt="GanttProject Logo">
                <span class="brand-name">GanttProject Cloud</span>
            </a>
            <!-- This is just a filler of space between [clickable] nav-brand and elements on the right -->
            <div class="flex-grow-1"></div>
              <slot></slot>
<!--            {{#if options.customUserBox}}-->
<!--            {{#template name=options.userBox}}{{/template}}-->
<!--            {{else}}-->
<!--            {{/if}}-->
        </div>
    </header>
</template>

<script lang="ts">
import {Component, Vue} from 'vue-facing-decorator';

@Component
export default class Header extends Vue {
    public readonly routes = {
      LANDING: '/',
      DASHBOARD: '/me',
    };
    public cdnUrl(path: string): string {
        return path;
    }
}
</script>

<style scoped>

</style>
